import { render } from "./LingoKidsBlog.vue?vue&type=template&id=2aa120b8"
import script from "./LingoKidsBlog.vue?vue&type=script&lang=js"
export * from "./LingoKidsBlog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__